import React from 'react';
import styled, { css } from 'styled-components';

import { MainForm } from 'helpers/form';
import { MOBILE, TABLET } from 'helpers/styles/media';

const FormBlock = () => {
  return (
    <Body>
      <MainForm
        hideLabels
        inputCss={inputStyles}
        prefixCss={prefixStyles}
        phoneCss={phoneStyles}
        buttonCss={buttonStyles}
      />
    </Body>
  );
};

const Body = styled.div`

`;

const inputStyles = css`
  border: 1px solid #767676;
  border-radius: 5px;
  height: 56px;
  background: transparent;

  @media ${MOBILE} {
    font-size: 13px;
  }
`;

const prefixStyles = css`
  flex: 0 0 105px;
  input {
    ${inputStyles}
  }
`;

const phoneStyles = css`
  input {
    ${inputStyles}
    height: 56px;
    background: transparent;
  }
`;

const buttonStyles = css`
  background-color: #ff0000;
  font-weight: 700;
  border-radius: 8px;
  padding: 10px;
  position: relative;
  text-align: center;
  min-height: 54px;
  transition: box-shadow 0.3s;
  color: #fff;
  font-size: 23px;
  cursor: pointer;

  &:hover {
    filter: brightness(95%);
  }

  @media ${TABLET} {
    height: auto;
  }
`;

export default FormBlock;
